export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./app.vue?vue&type=template&id=0a137e4e&"


//////////////////
// WEBPACK FOOTER
// ../assets/js/personalize/app.vue?vue&type=template&id=0a137e4e&
// module id = 80
// module chunks = 0